import angular from 'angular'
import companyInfoPage from 'app/system/systemsetting/company/view/companyInfo.html'
// import licensePage from 'app/system/systemsetting/license/view/license.html'
import passwordPoliciesPage from 'app/system/systemsetting/passwordPolicies/view/passwordPolicies.html'
import initStepPage from './view/template_init_step.html'
import changeInitPwdPage from './view/changeInitPw.html'
import { sysInitial } from 'redevConfig'
const changeInitPw = (sysInitial && sysInitial.changeInitPw) || ''

const changePwdPage = changeInitPw ? require(`redevelopment/main/sysInitial/${changeInitPw.templateName}`) : require('./view/changePw.html')
const InitPwCtrl = changeInitPw ? require(`redevelopment/main/sysInitial/${changeInitPw.controllerName}`) : require('./InitPwCtrl')

export default angular
    .module('app.sysInitial', [])
    .controller('InitPwCtrl', InitPwCtrl.default)
    .config(['$stateProvider', function config($stateProvider) {
        $stateProvider
            .state('index.changeInitPw', {
                url: '/changeInitPw',
                template: changePwdPage,
                controller: 'InitPwCtrl',
                title: '修改密码',
            })
            .state('initStep', {
                url: '/initStep',
                abstract: true,
                template: initStepPage,
                // controller: 'homeCtrl',
            })
            .state('initStep.initStepOne', {
                url: '/initStepOne',
                template: changeInitPwdPage,
                controller: 'InitPwCtrl',
                title: '修改密码',
            })
            .state('initStep.initStepTwo', {
                url: '/initStepTwo',
                template: companyInfoPage,
                controller: 'CompanyEditCtrl',
                title: '设置企业信息',
            })
            // .state('initStep.initStepThree', {
            //     url: '/initStepThree',
            //     template: licensePage,
            //     controller: 'licenseCtrl',
            //     title: '设置授权',
            // })
            .state('initStep.initStepFour', {
                url: '/initStepFour',
                template: passwordPoliciesPage,
                controller: 'passwordPoliciesCtrl',
                title: '密码策略',
            })
    }])
    .controller()
    .name



// WEBPACK FOOTER //
// ./src/app/main/sysinitial/index.js